// store/balance/useBalanceStore.ts

import { create } from 'zustand';

import { createExercicesSlice, EmpruntsActions } from './createEmpruntsSlice';
import { empruntsInitialState, EmpruntsState } from './empruntsInitialState';
import { persist, combine } from 'zustand/middleware';

/**
 * @french
 * Hook Zustand persistant pour la gestion de la balance comptable.
 */
export const useEmpruntsStore = create<EmpruntsState & EmpruntsActions>()(
  persist(combine(empruntsInitialState, createExercicesSlice as any), {
    name: 'emprunt-store',
  }),
);
